
import consent from "./consent";
import relationships from "./relationships";
import sex from "./sex";

const scenarios = {
    consent,
    sex,
    relationships,
}

export default scenarios;